import { isEmpty } from 'lodash'

// `selectedInput` is the DB column name to filter on, coming from
// searchDropDownOptionMapping.privateOffersOptionMapping (company_name,
// aws_offer_id, or private_offer_id). Maps it to the explicit query params
// getPrivateOffersData expects.
export const getPrivateOffersSearchParams = (
  input?: string,
  selectedInput?: string
) => {
  if (isEmpty(input)) {
    return {}
  }
  switch (selectedInput) {
    case 'aws_offer_id':
      return { awsOfferId: input }
    case 'private_offer_id':
      return { privateOfferId: input }
    case 'company_name':
      return { companyName: input }
    default:
      return {}
  }
}
